import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, TextField, IconButton } from '@material-ui/core/';
import Autocomplete from '@material-ui/lab/Autocomplete';
import t from "../../../languages/pl";
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';

const useStyles = theme => ({
    textfield: {
        width: 150
    },
    container: {
        display: "flex",
        alignItems: "center"
    },
    iconButton: {
        padding: theme.spacing(1)
    }
});

const SearchField = props => {
    const { classes, className, options, onChange, onClearClick } = props;
    const [value, setValue] = useState('');
    const [text, setText] = useState('');

    useEffect(() => {
        onChange && onChange(value);
    }, [value]);

    const handleTextFieldChange = e => {
        setText(e.target.value);
        if(e.target.value === "")
            setValue('');
    };

    const handleAutocompleteChange = (e, newValue) => {
        setValue(newValue);
        setText(newValue);
    };

    const handleClear = () => {
        handleAutocompleteChange(null, '');
        onClearClick && onClearClick();
    };

    return (
        <div className={className}>
            <div className={classes.container}>
            <Autocomplete
                freeSolo
                clearOnEscape
                options={[...new Set(options)]}
                value={value}
                onChange={handleAutocompleteChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t.search}
                        className={classes.textfield}
                        value={text}
                        onChange={handleTextFieldChange}
                    />
                )}
            />
            <IconButton
                className={classes.iconButton}
                onClick={() => setValue(text)}
            >
                <SearchIcon />
            </IconButton>
            <IconButton
                className={classes.iconButton}
                onClick={handleClear}
            >
                <ClearAllIcon />
            </IconButton>
            </div>
        </div>
    );
};

SearchField.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
    onClearClick: PropTypes.func
};

export default withStyles(useStyles)(SearchField);
